import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolsModule } from '../tools/tools.module';

import { OfferpackRoutingModule } from './offerpack-routing.module';
import { OfferpackComponent } from './offerpack.component';
import { AngularMaterialModule } from '../../material.module';
import { FooterModule } from '../footer/footer.module';
import { OfferpackcardComponent } from './offerpackcard/offerpackcard.component';
import { OffersToolsModule } from '../offers/offersTools.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OfferpackcruisecardComponent } from './offerpackcruisecard/offerpackcruisecard.component';
import { OfferpackpauschalcardComponent } from './offerpackpauschalcard/offerpackpauschalcard.component';
import { OfferpackspecinfoComponent } from './offerpackspecinfo/offerpackspecinfo.component';
import { OfferpackssktvcardComponent } from './offerpackssktvcard/offerpackssktvcard.component';
import { OfferpackflightcardComponent } from './offerpackflightcard/offerpackflightcard.component';
import { OfferpackcarrentcardComponent } from './offerpackcarrentcard/offerpackcarrentcard.component';
import { OfferpackftiticketshopcardComponent } from './offerpackftiticketshopcard/offerpackftiticketshopcard.component';
import { OfferpdfComponent } from './offerpdf/offerpdf.component';
import { OfferpackbookingcomcardComponent } from './offerpackbookingcomcard/offerpackbookingcomcard.component';
import { OfferpackcockpitcardComponent } from './offerpackcockpitcard/offerpackcockpitcard.component';
import { OfferpackdetailmodalComponent } from './offerpackdetailmodal/offerpackdetailmodal.component';
import { FlightDetailComponent } from './offerpackdetailmodal/flight-detail/flight-detail.component';
import { OfferpackdetailheaderComponent } from './offerpackdetailmodal/offerpackdetailheader/offerpackdetailheader.component';
import { AnmeldungsformComponent } from './offerpackdetailmodal/anmeldungsform/anmeldungsform.component';
import { OfferpackchamaeleoncardComponent } from './offerpackchamaeleoncard/offerpackchamaeleoncard.component';
import { OfferpackgetyourguidecardComponent } from './offerpackgetyourguidecard/offerpackgetyourguidecard.component';
import { OfferpackprofewocardComponent } from './offerpackprofewocard/offerpackprofewocard.component';
import { OfferpackDetailPersComponent } from './offerpackdetailmodal/offerpack-detail-pers/offerpack-detail-pers.component';
import { ChamealeonDetailComponent } from './offerpackdetailmodal/chamaeleon-detail/chamaeleon-detail.component';
import { GetyourguideDetailComponent } from './offerpackdetailmodal/getyourguide-detail/getyourguide-detail.component';
import { ProfweoDetailComponent } from './offerpackdetailmodal/profweo-detail/profweo-detail.component';
import { PipeModule } from '@app/pipe/pipe.module';
import { FlightMiniDetailComponent } from './offerpackdetailmodal/flight-mini-detail/flight-mini-detail.component';
import { ChamaeleonMiniDetailComponent } from './offerpackdetailmodal/chamaeleon-mini-detail/chamaeleon-mini-detail.component';
import { GetyourguideMiniDetailComponent } from './offerpackdetailmodal/getyourguide-mini-detail/getyourguide-mini-detail.component';
import { ProfewoMiniDetailComponent } from './offerpackdetailmodal/profewo-mini-detail/profewo-mini-detail.component';
import { BoolingcomDetailComponent } from './offerpackdetailmodal/boolingcom-detail/boolingcom-detail.component';
import { OfferpackedomizilcardComponent } from './offerpackedomizilcard/offerpackedomizilcard.component';
import { PauschalDetailComponent } from './offerpackdetailmodal/pauschal-detail/pauschal-detail.component';
import { SktvDetailComponent } from './offerpackdetailmodal/sktv-detail/sktv-detail.component';
import { KeywordsModule } from '../keywords/keywords.module';
import { FlugDetailMComponent } from './offerpackdetailmodal/flug-detail/flug-detail.component';
import { CruisDetailComponent } from './offerpackdetailmodal/cruis-detail/cruis-detail.component';
import { CruiseModule } from '../cruise/cruise.module';
import { CommentComponent } from './comment/comment.component';
import { HeaderModule } from '../header/header.module';
import { ImagesliderComponent } from '../imageslider/imageslider.component';
import { ShareComponent } from '../share/share.component';
import { OfferpackratehawkcardComponent } from './offerpackratehawkcard/offerpackratehawkcard.component';
import { RatehawkDetailComponent } from './offerpackdetailmodal/ratehawk-detail/ratehawk-detail.component';
import { DirectiveModule } from '@app/directives/directive.module';

@NgModule({
    declarations: [
        OfferpackComponent,
        OfferpackcardComponent,
        OfferpackcruisecardComponent,
        OfferpackpauschalcardComponent,
        OfferpackspecinfoComponent,
        OfferpackssktvcardComponent,
        OfferpackflightcardComponent,
        OfferpackcarrentcardComponent,
        OfferpackftiticketshopcardComponent,
        OfferpdfComponent,
        OfferpackbookingcomcardComponent,
        OfferpackprofewocardComponent,
        OfferpackcockpitcardComponent,
        OfferpackdetailmodalComponent,
        OfferpackchamaeleoncardComponent,
        OfferpackgetyourguidecardComponent,
        FlightDetailComponent,
        OfferpackDetailPersComponent,
        OfferpackdetailheaderComponent,
        AnmeldungsformComponent,
        ChamealeonDetailComponent,
        GetyourguideDetailComponent,
        ProfweoDetailComponent,
        FlightMiniDetailComponent,
        ChamaeleonMiniDetailComponent,
        GetyourguideMiniDetailComponent,
        ProfewoMiniDetailComponent,
        BoolingcomDetailComponent,
        OfferpackedomizilcardComponent,
        PauschalDetailComponent,
        SktvDetailComponent,
        FlugDetailMComponent,
        CruisDetailComponent,
        OfferpackratehawkcardComponent,
        CommentComponent,
        RatehawkDetailComponent
    ],
    imports: [
        ToolsModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        OfferpackRoutingModule,
        FooterModule,
        AngularMaterialModule,
        OffersToolsModule,
        ImagesliderComponent,
        ShareComponent,
        PipeModule,
        DirectiveModule,
        KeywordsModule,
        CruiseModule,
        HeaderModule
    ]
})
export class OfferpackModule { }
